import axios from "axios";
import { useMutation, useQuery } from '@tanstack/react-query';

// import AppInsight from "./AppInsight";

export const getMSID = () => {
    try {
      const userInfoData = JSON.parse(getCookie('userInfo'));
      return userInfoData.sub;
    }
    catch (error) {
      // AppInsight.trackEvent({ name: 'PNA Frontend => getMSID', properties: { errorMessage: error.message } });
    }
  }
  export const getName = () => {
    try {
      const userInfoData = JSON.parse(getCookie('userInfo'));
      return userInfoData.displayName;
    }
    catch (error) {
      // AppInsight.trackEvent({ name: 'PNA Frontend => getName', properties: { errorMessage: error.message } });
    }
  }
  export const getEmail = () => {
    try {
      const userInfoData = JSON.parse(getCookie('userInfo'));
      return userInfoData.email;
    }
    catch (error) {
      // AppInsight.trackEvent({ name: 'PNA Frontend => getEmail', properties: { errorMessage: error.message } });
    }
  }
  export const getToken =  () => {
    try {
      const authToken = getCookie('authAccessTokenInfo');
      return authToken;
    }
    catch (error) {
      // AppInsight.trackEvent({ name: 'PNA Frontend => getEmail', properties: { errorMessage: error.message } });
    }
  }
  export const isAuthenticatedUser = () => {
    try {
      const userInfoData = JSON.parse(getCookie('userInfo'));
      return userInfoData !== null && userInfoData !== "" ? true :false;
    }
    catch (error) {
      // AppInsight.trackEvent({ name: 'PNA Frontend => getEmail', properties: { errorMessage: error.message } });
    }
  }



export const setCookie = (name, value, minutes) => {
  // set cookies local to use in all app
  // console.log('Set coocies', name, value, minutes);
  let expires = '';
  if (minutes) {
    const date = new Date();
    date.setMinutes(date.getMinutes() + minutes);
    expires = `; expires${date.toUTCString()}`;
  }
  // console.log('************', (document.cookie = `${name}=${value || ''}${expires}; path=/`));
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
  // console.log(' after Set coocies', document.cookie);
};
 
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const getAccessToken = async (accessCode) => {
    const config = {
    method: 'post',
    url: process.env.REACT_APP_PING_TOKEN_URI,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: {
      grant_type:process.env.REACT_APP_PING_AUTH_CODE,
      code:accessCode,
      redirect_uri:process.env.REACT_APP_PING_REDIRECT_URI,
      client_id:process.env.REACT_APP_PING_CLIENT_ID,
      code_verifier:process.env.REACT_APP_PING_CODE_VERIFIER,
    },
  };
  return await axios(config)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      // AppInsight.trackEvent({ name: 'PNA Frontend => getAccessToken', properties: { errorMessage: e.message } });
      return { data: [] }; 
    });
};
export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
  return JSON.parse(jsonPayload);
};

export const useAccessTokenByRefresh = () => {

    return useMutation({
         mutationFn: async ({body,config}) => {
            try {

                const res = await axios.post(`${process.env.REACT_APP_PING_TOKEN_URI}`, body, config);

                if (res.data.error) {
                    console.error("API returned an error:", res.data.error);
                    throw new Error(res.data.message || "An unknown error occurred");
                }

                return res.data;
            } catch (err) {
                console.error("Error during API call:", err);
                const errorMessage = err.response?.data?.message || "Failed to Update Status";
                throw new Error(errorMessage);
            }
         }
    });
};


export function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}


export const getUserRole = () => {
  let userRole = 0; // Default role is non-admin
  try {
    const userInfoData = JSON.parse(getCookie('userInfo') || '{}');
    if (userInfoData?.groups?.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN)) {
      userRole = 1; // Admin
    } else {
      userRole = 0; // Non-admin
    }
  } catch (error) {
    console.error("Error parsing userInfo cookie:", error);
    userRole = 0; // Fallback to non-admin
  }

  return userRole;
};